export { default as ScreenBuildingAdd } from './add'
export { default as ScreenBuildingEdit } from './edit'
export { default as ScreenBuildingDetail } from './detail'
